import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { CREATED_DATE } from 'customer-data-objects/task/TaskPropertyNames';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';
import DateTimeCell from './DateTimeCell';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskCreationDateCell = ({
  original: cdtTask
}) => {
  const createdAtDate = getProperty(cdtTask, CREATED_DATE);
  return /*#__PURE__*/_jsx(DateTimeCell, {
    format: "LLL",
    i18nTimezoneType: TimezoneTypes.USER,
    value: createdAtDate
  });
};
export default TaskCreationDateCell;